import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { Logo } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) return setError("Password must be at least 8 characters.");
    if (password !== confirm) return setError("Passwords do not match.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      setError(apiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  const input = "h-11 w-full rounded-lg border border-input bg-card px-3.5 text-sm outline-none focus:ring-2 focus:ring-ring";
  return (
    <div className="grid min-h-screen place-items-center bg-[#0D0F12] px-6">
      <div className="w-full max-w-md rounded-2xl bg-card p-8 shadow-xl" data-testid="reset-password-page">
        <Logo wm={28} tone="light" />
        <h2 className="mt-6 font-heading text-[22px] font-semibold">Choose a new password</h2>
        {!token ? (
          <p className="mt-2 text-sm text-muted-foreground" data-testid="reset-password-missing">This reset link is incomplete. Please use the link from your email.</p>
        ) : (
          <form onSubmit={submit} className="mt-4 space-y-4" data-testid="reset-password-form">
            <input data-testid="reset-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={input} placeholder="New password (at least 8 characters)" />
            <input data-testid="reset-password-confirm-input" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className={input} placeholder="Repeat new password" />
            {error && <div data-testid="reset-password-error" className="rounded-lg bg-destructive/10 px-3 py-2 text-sm text-destructive">{error}</div>}
            <Button type="submit" disabled={loading} data-testid="reset-password-submit-button" className="btn-brand h-11 w-full">
              {loading ? "Saving…" : "Save new password"}
            </Button>
          </form>
        )}
        <Link to="/login" className="mt-5 block text-sm text-[#1779AC] hover:underline" data-testid="back-to-login-link">Back to sign in</Link>
      </div>
    </div>
  );
}
